"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SideNavVersion2 = void 0;
var _react = require("react");
var _SideNav = _interopRequireDefault(require("./SideNav2"));
const SideNavVersion2 = _SideNav["default"];
exports.SideNavVersion2 = SideNavVersion2;
const SideNav = _ref => {
  let {
    topOffset
  } = _ref;
  const [offset, setOffset] = (0, _react.useState)(topOffset || 'auto');
  return null;
};
var _default = SideNav;
exports["default"] = _default;